import React from "react"

import { Link } from "gatsby"

import PropTypes from "prop-types"
import Fade from "react-reveal/Fade"

import "./Minimum20.scss"

const Minimum20 = ({ section }) => {
  return (
    <section className="minimum-20">
      <Fade>
        <div className="minimum-20__wrapper">
          <div className="minimum-20__wrapper__text">
            <p className="minimum-20__wrapper__text__title">
              {section.title || "Lorem Ipsum Title"}
            </p>
            <p className="minimum-20__wrapper__text__discount">
              {section.discountText || "Lorem Ipsum"}
            </p>
            <button className="minimum-20__wrapper__text__btn">
              <Link to={`/${section.buttonLink}`}>
                {section.buttonText || "Lorem Ipsum"}
              </Link>
            </button>
          </div>
          <img
            className="minimum-20__wrapper__image1"
            src={
              section.image1?.url ||
              "https://images.unsplash.com/photo-1543322748-33df6d3db806?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8M3w0NjQ5MzE5fHxlbnwwfHx8fA%3D%3D&auto=format&fit=crop&w=500&q=60"
            }
            alt={section.image1?.alt}
            loading="lazy"
          />
        </div>
      </Fade>
    </section>
  )
}

Minimum20.propTypes = {
  section: PropTypes.object.isRequired,
}

export default Minimum20
